(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dose-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const heroSections = document.querySelectorAll('.dose-hero');

    heroSections.forEach(function(heroSection) {
      const desktopVideo = heroSection.querySelector('.dose-hero__video--desktop');
      const mobileVideo = heroSection.querySelector('.dose-hero__video--mobile');
      if (!desktopVideo && !mobileVideo) return;

      // Ensure background behavior for Safari/Chrome mobile
      [desktopVideo, mobileVideo].forEach(function(v) {
        if (!v) return;
        try {
          v.setAttribute('muted', '');
          v.muted = true;
          v.setAttribute('playsinline', '');
          v.setAttribute('webkit-playsinline', '');
          v.setAttribute('x5-playsinline', '');
          v.setAttribute('autoplay', '');
          v.setAttribute('loop', '');
          // Ensure no controls attribute is present for background video
          v.removeAttribute('controls');
          v.controls = false;
          v.setAttribute('disablepictureinpicture', '');
          v.setAttribute('disableremoteplayback', '');
        } catch (e) {}
      });

      const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
      const getActiveVideo = () => {
        if (mobileVideo && isMobile()) return mobileVideo;
        return desktopVideo || mobileVideo;
      };

      let playButtonEl = null;

      function pauseInactive(activeVideo) {
        [desktopVideo, mobileVideo].forEach(function(v) {
          if (v && v !== activeVideo) {
            try { v.pause(); } catch (e) {}
          }
        });
      }

      // Function to attempt video play on the active source
      function attemptVideoPlay() {
        const activeVideo = getActiveVideo();
        if (!activeVideo) return;
        pauseInactive(activeVideo);

        if (activeVideo.paused) {
          activeVideo.play().catch(function(error) {
            console.log('Video autoplay failed:', error);
            showPlayButton();
          });
        }
      }

      // Function to show play button when autoplay fails
      function showPlayButton() {
        if (playButtonEl) return;
        const btn = document.createElement('button');
        btn.className = 'dose-hero__play-button';
        btn.innerHTML = `
          <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="30" cy="30" r="30" fill="rgba(0,0,0,0.7)"/>
            <path d="M25 20L25 40L40 30L25 20Z" fill="white"/>
          </svg>
        `;
        btn.style.cssText = `
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: none;
          border: none;
          cursor: pointer;
          z-index: 10;
          opacity: 0.8;
          transition: opacity 0.3s ease;
        `;

        btn.addEventListener('click', function() {
          const activeVideo = getActiveVideo();
          if (activeVideo) activeVideo.play();
          if (playButtonEl) playButtonEl.remove();
          playButtonEl = null;
        });

        btn.addEventListener('mouseenter', function() {
          btn.style.opacity = '1';
        });

        btn.addEventListener('mouseleave', function() {
          btn.style.opacity = '0.8';
        });

        heroSection.querySelector('.dose-hero__video-wrapper').appendChild(btn);
        playButtonEl = btn;
      }

      // Try to play immediately
      attemptVideoPlay();

      // Also try on user interaction (for browsers that block autoplay)
      const userInteractionEvents = ['click', 'touchstart', 'keydown'];
      userInteractionEvents.forEach(function(event) {
        document.addEventListener(event, function() {
          attemptVideoPlay();
        }, { once: true });
      });

      // Handle video events
      [desktopVideo, mobileVideo].forEach(function(v) {
        if (!v) return;
        v.addEventListener('loadeddata', attemptVideoPlay);
        v.addEventListener('canplay', attemptVideoPlay);
      });

      // Handle viewport changes switching between videos
      window.addEventListener('resize', attemptVideoPlay);
      window.addEventListener('orientationchange', attemptVideoPlay);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dose-video-centered"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const videoSections = document.querySelectorAll('.dose-video-centered');
    
    videoSections.forEach(function(section) {
      const video = section.querySelector('.dose-video-centered__video');
      const unmuteButton = section.querySelector('.dose-video-centered__unmute-button');
      
      if (!video || !unmuteButton) return;

      let isMuted = true;

      // Function to attempt video play
      function attemptVideoPlay() {
        if (video.paused) {
          video.play().catch(function(error) {
            console.log('Video autoplay failed:', error);
          });
        }
      }

      // Function to toggle mute/unmute
      function toggleMute() {
        if (isMuted) {
          video.muted = false;
          isMuted = false;
          unmuteButton.innerHTML = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 9V15H7L12 20V4L7 9H3Z" fill="currentColor"/>
              <path d="M16.5 12C16.5 10.23 15.48 8.71 14 7.97V16.02C15.48 15.29 16.5 13.77 16.5 12Z" fill="currentColor"/>
              <path d="M14 3.23V5.29C16.89 6.15 19 8.83 19 12C19 15.17 16.89 17.85 14 18.71V20.77C18.01 19.86 21 16.28 21 12C21 7.72 18.01 4.14 14 3.23Z" fill="currentColor"/>
            </svg>
          `;
          unmuteButton.setAttribute('aria-label', 'Mute video');
        } else {
          video.muted = true;
          isMuted = true;
          unmuteButton.innerHTML = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 9V15H7L12 20V4L7 9H3Z" fill="currentColor"/>
              <path d="M16.5 12C16.5 10.23 15.48 8.71 14 7.97V16.02C15.48 15.29 16.5 13.77 16.5 12Z" fill="currentColor"/>
              <path d="M14 3.23V5.29C16.89 6.15 19 8.83 19 12C19 15.17 16.89 17.85 14 18.71V20.77C18.01 19.86 21 16.28 21 12C21 7.72 18.01 4.14 14 3.23Z" fill="currentColor"/>
            </svg>
          `;
          unmuteButton.setAttribute('aria-label', 'Unmute video');
        }
      }

      // Event listeners
      unmuteButton.addEventListener('click', toggleMute);

      // Try to play immediately
      attemptVideoPlay();

      // Also try on user interaction (for browsers that block autoplay)
      const userInteractionEvents = ['click', 'touchstart', 'keydown'];
      userInteractionEvents.forEach(event => {
        document.addEventListener(event, function() {
          attemptVideoPlay();
        }, { once: true });
      });

      // Handle video events
      video.addEventListener('loadeddata', function() {
        attemptVideoPlay();
      });

      video.addEventListener('canplay', function() {
        attemptVideoPlay();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
